import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-license-error',
    templateUrl: './license-error.component.html',
    styleUrls: ['./license-error.component.scss']
})
export class LicenseErrorComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
